import { InjectionToken, signal, WritableSignal } from '@angular/core';
import { LegalEntityResponse } from 'angular-api-gateway/v1/model/legalEntityResponse';

export const LEGAL_ENTITY_DATA: InjectionToken<WritableSignal<LegalEntityResponse>> = new InjectionToken(
  'LEGAL_ENTITY_DATA',
  {
    providedIn: 'root',
    factory: (): WritableSignal<LegalEntityResponse> => signal<LegalEntityResponse | null>(null),
  }
);
